import { render, staticRenderFns } from "./PassageDialog.vue?vue&type=template&id=65b1362e&scoped=true"
import script from "./PassageDialog.vue?vue&type=script&lang=ts"
export * from "./PassageDialog.vue?vue&type=script&lang=ts"
import style0 from "./PassageDialog.vue?vue&type=style&index=0&id=65b1362e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b1362e",
  null
  
)

export default component.exports